( function ( _s ) {
	let scrolled = false;
	let element = false;
	let _element = false;

	const scrollEnded = top => {
		return Math.abs( top - window.scrollY ) < 10;
	};

	const scrollListener = top => {
		const _header = _s( '#app > header' );

		_header.addClass( 'locked-hidden' );

		const listenScroll = () => {
			if ( scrollEnded( top ) ) {
				window.removeEventListener( 'scroll', listenScroll );

				setTimeout( () => {
					_header.removeClass( 'show' );
					_header.removeClass( 'locked-hidden' );

					_s( window ).trigger( 'fr:unlock-body-top-padding' );
				}, 1000 );
			}
		};

		window.addEventListener( 'scroll', listenScroll );
	};

	function smoothScrollToHash() {
		if ( _element.length ) {
			if ( ! scrolled ) {
				const elementTop = _s( element ).offset().top;
				const elementHasPadding = parseInt( _element.css( 'paddingTop' ) );

				let offset = 0;

				if ( ! elementHasPadding ) {
					offset = 60;
				}

				window.scrollTo( {
					top: parseInt( elementTop - offset ),
					behavior: 'smooth',
				} );

				scrollListener( parseInt( elementTop - offset ) );

				scrolled = true;
			}
		}
	}

	if ( window.location.hash ) {
		const originalHash = window.location.hash;
		const hash = originalHash.substring( 1 );

		element = document.getElementById( hash );
		_element = _s( element );

		if ( _element.length ) {
			_s( document ).ready( () => {
				const resizeCallback = () => {
					smoothScrollToHash();
				};

				const debouncedResizeCallback = window.debounce( resizeCallback, 500 );

				const resizeObserver = new ResizeObserver( () => {
					debouncedResizeCallback();
				} );

				resizeObserver.observe( _s( 'body' ).firstElement() );
			} );
		}
	}
} )( window._s );
